import { post,postAES } from "@/api/request"

//
export const getAucClass = params => post("/v1/search/banner", params)
export const getAucProduct = params => postAES("/v3/auctions/index", params)

// 拍品列表--预展拍卖会
export const getRecoMeeting = params => post("/v1/recommend/session", params)
export const getRecoAuction = params => post("/v1/recommend/auction", params)

// 拍卖会
export const getAucMeet = params => postAES("/v3/session/index", params)
// 专场
export const getAucSpecial = params => postAES("/v3/special/list", params)
